import { Query as carouselQuery } from './carousels/carouselResolverOverrides';

const resolverOverrides = () => ({
  Query: { ...carouselQuery },
});

export default resolverOverrides;
